
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductSpecificationsDialog extends Serenity.EntityDialog<ProductSpecificationsRow, any> {
        protected getFormKey() { return ProductSpecificationsForm.formKey; }
        protected getIdProperty() { return ProductSpecificationsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductSpecificationsRow.localTextPrefix; }
        protected getNameProperty() { return ProductSpecificationsRow.nameProperty; }
        protected getService() { return ProductSpecificationsService.baseUrl; }
        protected getDeletePermission() { return ProductSpecificationsRow.deletePermission; }
        protected getInsertPermission() { return ProductSpecificationsRow.insertPermission; }
        protected getUpdatePermission() { return ProductSpecificationsRow.updatePermission; }

        protected form = new ProductSpecificationsForm(this.idPrefix);

        private loadedState: string;

        constructor() {
            super();

            this.form.EValidityType.changeSelect2(e => {
                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);

                }
                else {

                    if (vValidityType == '1' || vValidityType == '2') {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                        }
                        else {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                        }
                    }

                }

            });
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }
        loadEntity(entity: ProductsRow) {
            super.loadEntity(entity);

            if (this.isNew()) {
                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
            }
            else {

                var vValidityType = this.form.EValidityType.value;

                if (Q.isEmptyOrNull(vValidityType)) {
                    // this.setProductDetails({});
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);

                }
                else {

                    if (vValidityType == '1' || vValidityType == '2') {

                        if (vValidityType == '2') {
                            this.form.ValidTill.getGridField().toggle(false);
                            this.form.EValidity.getGridField().toggle(true);
                        }
                        else {
                            this.form.ValidTill.getGridField().toggle(true);
                            this.form.EValidity.getGridField().toggle(false);
                        }
                    }

                }
            }
            
        }

    }
}
